/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  IAGStakePoolManager,
  IAGStakePoolManagerInterface,
} from "../IAGStakePoolManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "addRevenueToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeDays",
        type: "uint16",
      },
    ],
    name: "removeStakeDays",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "revenueId",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "revenueDrawedToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "revenueId",
        type: "uint32",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "setRevenue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "stakeDays",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "multiple",
        type: "uint16",
      },
    ],
    name: "setStakeDays",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "revenueId",
        type: "uint32",
      },
    ],
    name: "startRevenueDraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "revenueId",
        type: "uint32",
      },
      {
        internalType: "uint256",
        name: "expireDuration",
        type: "uint256",
      },
    ],
    name: "stopCollectRevenueTicks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IAGStakePoolManager__factory {
  static readonly abi = _abi;
  static createInterface(): IAGStakePoolManagerInterface {
    return new utils.Interface(_abi) as IAGStakePoolManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IAGStakePoolManager {
    return new Contract(address, _abi, signerOrProvider) as IAGStakePoolManager;
  }
}
